import {api} from './requestGraphql.js'

const currencies = async () => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            currencies{
                id    
                name
            } 
          }
        `,
      }
    )

    let response = res.data.data.currencies
    console.log(` *** currencies from DB response count:${JSON.stringify(response)}` )
    return response
  } catch (e) {
    console.log(e)
  }

}

export default {
  currencies
}